export interface ResetToPhaseOneReason {
	code: string;
	message: string;
}

export interface ResetToPhaseOneDecision {
	canReset: boolean;
	reasons: ResetToPhaseOneReason[];
}

export const isResetToPhaseOneDecision = (value: unknown): value is ResetToPhaseOneDecision => {
	if (typeof value !== 'object' || value === null) return false;

	const decision = value as { canReset?: unknown; reasons?: unknown };
	if (typeof decision.canReset !== 'boolean' || !Array.isArray(decision.reasons)) return false;

	return decision.reasons.every((reason) => {
		if (typeof reason !== 'object' || reason === null) return false;

		const typedReason = reason as { code?: unknown; message?: unknown };
		return typeof typedReason.code === 'string' && typeof typedReason.message === 'string';
	});
};
